import React from 'react';
import { MapPin, Navigation, Phone } from 'lucide-react';
import { business, serviceAreas } from '../data/site';
import { SectionHeading } from './SectionHeading';
import { ServiceAreaMap } from './ServiceAreaMap';
export function ServiceAreas() {
  return <section id="areas" className="bg-white py-20 lg:py-28" data-id="element-178" data-mp="2loh0nfj571ge">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-179" data-mp="2pr3o748s607s">
        <SectionHeading eyebrow={`Based in ${business.base}`} tone="light" title={<>
              We haul the shop
              <br data-id="element-181" data-mp="2gsrzj7rh5chz" />
              to your gate
            </>} description={`Mobile welding and fabrication across Denton County and the surrounding ${serviceAreas.radiusMiles}-mile radius. Outside the circle? Call anyway — larger jobs travel.`} data-id="element-180" data-mp="2bsngpb33g5ol" />

        <div className="mt-14 grid gap-6 lg:grid-cols-[1.35fr_1fr]" data-id="element-182" data-mp="11nmuzpl2kgd">
          <div className="bg-steel-950 p-3" data-id="element-183" data-mp="52fwhu2dard6">
            <ServiceAreaMap data-id="element-184" data-mp="514spu8x9jm2" />
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 px-3 py-4" data-id="element-185" data-mp="6a12ry0s60es">
              <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white" data-id="element-186" data-mp="67y1uiy3amva">
                <span className="h-2.5 w-2.5 rounded-full bg-brand" aria-hidden="true" data-id="element-187" data-mp="fzuc0sdga3fv" />
                Shop — {business.base}
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-steel-300" data-id="element-188" data-mp="b22973b9owww">
                {serviceAreas.radiusMiles}-mile mobile service radius
              </span>
            </div>
          </div>

          <div className="grid gap-6" data-id="element-189" data-mp="3ejaphiqcjopi">
            <div className="border-2 border-steel-950 p-8" data-id="element-190" data-mp="3teguq3hmbjhs">
              <div className="flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-steel-950" data-id="element-191" data-mp="3tcnp8riqr5bd">
                <MapPin className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-192" data-mp="18ohqo53p1ukg" />
                Primary Towns
              </div>
              <ul className="mt-6 grid grid-cols-2 gap-x-6" data-id="element-193" data-mp="13q7w9wpsmxzw">
                {serviceAreas.primary.map(town => <li key={town.name} className="flex items-baseline gap-3 border-b border-steel-100 py-3 font-display text-lg font-semibold uppercase tracking-tight text-steel-950" data-id="element-194" data-mp="1artkiwyjvxax">
                    <span className="h-1.5 w-1.5 shrink-0 bg-brand" aria-hidden="true" data-id="element-195" data-mp="1koyaz8zfiexj" />
                    {town.name}
                  </li>)}
              </ul>

              <div className="mt-8 flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.22em] text-steel-500" data-id="element-196" data-mp="s3ybtrhsp9oo">
                <Navigation className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-197" data-mp="120b7uw0tbzml" />
                Also Serving
              </div>
              <ul className="mt-4 flex flex-wrap gap-2" data-id="element-198" data-mp="16r9mlr65kpnq">
                {serviceAreas.extended.map(town => <li key={town} className="border border-steel-200 bg-steel-50 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-steel-600" data-id="element-199" data-mp="9auh02sucqsh">
                    {town}
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-steel-200 pt-6" data-id="element-200" data-mp="2nkpxxwl7i8t7">
                <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-steel-500" data-id="element-201" data-mp="2ijshbofuhmtt">
                  Counties
                </div>
                <p className="mt-3 font-display text-lg uppercase tracking-tight text-steel-950" data-id="element-202" data-mp="2dkz47x4gzxu6">
                  {serviceAreas.counties.join(' · ')}
                </p>
              </div>
            </div>

            <div className="flex flex-col justify-between gap-6 bg-steel-950 p-8 sm:flex-row sm:items-center" data-id="element-203" data-mp="23tb5rc9hxgj7">
              <p className="font-display text-2xl font-bold uppercase leading-[0.95] text-white" data-id="element-204" data-mp="1zrg426nnl14w">
                Not on the list?
                <span className="block text-brand-light" data-id="element-205" data-mp="1pw66pw879hxg">Call and ask.</span>
              </p>
              <a href={business.phoneHref} className="inline-flex shrink-0 items-center justify-center gap-3 bg-brand px-6 py-4 font-display text-sm font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-206" data-mp="1kw1n3xbzw730">
                <Phone className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="3b9jalscn2hif" />
                {business.phone}
              </a>
            </div>
          </div>
        </div>

        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-steel-300" data-id="element-208" data-mp="3g5zzwpvkr1x3">
          Placeholder service areas — confirm final coverage
        </p>
      </div>
    </section>;
}